// Packages

// Components

// Logic
import { CharacterCardLogic } from "./CharacterCardLogic";

// Context

// Styles
import "./CharacterCard.css";

// Assets

export const CharacterCard = ({ character }) => {
	const { entityTypes, getCardEntityTypeClassName } = CharacterCardLogic();

	return (
		<div className='landing-character-card' style={character.colour ? { borderColor: character.colour } : {}}>
			{character.cardImage ? (
				<img
					className='landing-character-card-background-image'
					src={character.cardImage}
					alt=''
					style={character.colour ? { borderColor: character.colour } : {}}
				/>
			) : (
				<div className='landing-character-card-background-colour' style={character.colour ? { borderColor: character.colour } : {}} />
			)}

			<div className='landing-character-card-content'>
				<div className='landing-character-card-top'>
					<div className='landing-character-card-top-name' style={character.colour ? { color: character.colour } : {}}>
						{character.name}
					</div>
					{character.entityType === undefined ? null : (
						<div className={getCardEntityTypeClassName(character.entityType)}>
							<p>{entityTypes[character.entityType]}</p>
						</div>
					)}
				</div>
				<div className='landing-character-card-info-container'>
					{!character.primaryAbility ? null : (
						<div className='landing-character-card-info' style={character.colour ? { background: character.colour } : {}}>
							<p className='landing-character-card-info-label'>Primary Ability</p>
							<p className='landing-character-card-info-value'>{character.primaryAbility}</p>
						</div>
					)}
					{!character.descriptives ? null : (
						<div className='landing-character-card-info' style={character.colour ? { background: character.colour } : {}}>
							<p className='landing-character-card-info-label'>Descriptives</p>
							<p className='landing-character-card-info-value'>{character.descriptives}</p>
						</div>
					)}
					{!character.represents ? null : (
						<div className='landing-character-card-info' style={character.colour ? { background: character.colour } : {}}>
							<p className='landing-character-card-info-label'>Represents</p>
							<p className='landing-character-card-info-value'>{character.represents}</p>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};
